//Help page dynamic components
const helpPageCards = [
    {
        title: "Welcome",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/welcome",
    },
    {
        title: "What is SmoothHiring ?",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/what-is-smoothhiring",
    },
    {
        title: "Is it easy?",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/is-it-easy",
    },
    {
        title: "Is it fast?",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/is-it-fast",
    },
    {
        title: "What does it cost?",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/what-does-it-cost",
    },
    {
        title: "Lots of candidates?",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/lots-of-candidates",
    },
    {
        title: "What do I get?",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/what-do-i-get",
    },
    {
        title: "Does it really work?",
        desc: "Create, optimize and manage your account",
        image: 'card8',
        path: "/employer/help/does-it-work",
    },
    {
        title: "Can I get help?",
        desc: "Create, optimize and manage your account",
        image: 'card9',
        path: "/employer/help/can-i-get-help",
    },
    {
        title: "Welcome",
        desc: "Create, optimize and manage your account",
        image: 'card1',
        path: "/employer/help/welcome",
    },
]

export default helpPageCards;